type WebRuntimeEnv = {
  VITE_API_BASE_URL?: string;
};

export function getApiBaseUrl(env: WebRuntimeEnv = import.meta.env as WebRuntimeEnv): string {
  return env.VITE_API_BASE_URL?.trim().replace(/\/+$/, '') ?? '';
}

export function buildApiUrl(
  path: string,
  env: WebRuntimeEnv = import.meta.env as WebRuntimeEnv,
): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${getApiBaseUrl(env)}${normalizedPath}`;
}
